<div
  class="flex h-[40px] w-full flex-row"
  *ngIf="[rowTypeMetric, rowTypeFormula].indexOf(params.data.rowType) > -1"
>
  <div
    echarts
    [initOpts]="localInitOpts"
    [options]="localOptions"
    (chartInit)="onChartInit($event)"
    class="my-echarts overflow-hidden"
    style="width: 100%; height: 100%"
  ></div>
</div>
